import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const StyledStagesBreadcrumbs = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${colors.textSecondary};
  cursor: default;
  font-size: 12px;

  .active {
    color: ${colors.textPrimary}
  }
`